module.exports = __webpack_public_path__ + "static/media/plane(7).e79bff42.PNG";